// import { Spinner } from 'flowbite-react';

const CircularProgressWithLabel = () => {
  return <div>Loading</div>;
  // return <Spinner aria-label="Default status example" />;
};

export default CircularProgressWithLabel;
